module.exports = isHook

function isHook(hook) {
    return hook &&
      (typeof hook.hook === "function" && !hook.hasOwnProperty("hook") ||
       typeof hook.unhook === "function" && !hook.hasOwnProperty("unhook"))
}



// WEBPACK FOOTER //
// ./node_modules/virtual-dom/vnode/is-vhook.js